import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_DESIGNATIONS,
  CREATE_DESIGNATION_REQUEST,
  DELETE_DESIGNATION,
} from "./actionTypes";
import {
  fetchDesignations,
  fetchDesignationsSuccess,
  fetchDesignationsFailure,
  createDesignationSuccess,
  createDesignationFailure,
  deleteDesignationSuccess,
  deleteDesignationFailure,
} from "./actions";
import { post } from "../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Designations Saga
function* fetchDesignationsSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_GET_DESIGNATIONS, formData);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve designations!");
    }

    yield put(fetchDesignationsSuccess(response));
  } catch (error) {
    console.error("Fetch Designations Saga Error:", error);
    yield put(fetchDesignationsFailure(error.message));
  }
}

// Create Designation Saga
function* createDesignationSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const response = yield call(post, process.env.REACT_APP_CREATE_DESIGNATION, formData);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Designation saved successfully!",
      });
      yield put(createDesignationSuccess(response));
      const unitId = formData.get("unit_id"); 
      if (unitId) {
        yield put(fetchDesignations(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(createDesignationFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Create Designation Saga Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the designation",
    });
    yield put(createDesignationFailure(error.message));
  }
}

// Delete Designation Saga
function* deleteDesignationSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_DELETE_DESIGNATION, action.payload);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: response.message || "Designation deleted successfully!",
      });
      yield put(deleteDesignationSuccess(response));
      const unitId = action.payload.get("unit_id"); 
      if (unitId) {
        yield put(fetchDesignations(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Failed to delete designation!",
      });
      yield put(deleteDesignationFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Delete Designation Saga Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while deleting the designation",
    });
    yield put(deleteDesignationFailure(error.message));
  }
}

// Watcher Saga
function* designationSaga() {
  yield takeEvery(FETCH_DESIGNATIONS, fetchDesignationsSaga);
  yield takeEvery(CREATE_DESIGNATION_REQUEST, createDesignationSaga);
  yield takeEvery(DELETE_DESIGNATION, deleteDesignationSaga);
}

export default designationSaga;
